import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ServiceSearchKey } from 'src/app/shared/models/service';
import { DataService } from 'src/app/shared/services/data-service/data.service';

@Component({
  selector: 'search-key-input',
  templateUrl: './search-key-input.component.html',
  styleUrls: ['./search-key-input.component.scss'],
})
export class SearchKeyInputComponent {
  isLoading: boolean;
  readonly MINIMUM_SEARCH_TERM_LENGTH: number = 3;
  keyword = 'dropdownName';
  data: ServiceSearchKey[] = [];

  @Input() error: string;
  @Input() selectedValue: string;
  @Input() clickedValue: ServiceSearchKey;
  @Input() serviceId: string;
  @Input() key: string;
  @Input() initialValue: string;
  @Input() minQueryLength: number;
  @Output() selectedValueChange = new EventEmitter<string>();
  @Output() clickedValueChange = new EventEmitter<ServiceSearchKey>();
  @ViewChild('auto') auto: any;

  constructor(private dataService: DataService) {}

  selectEvent(item: ServiceSearchKey) {
    if (!item.value) return;
    this.clickedValue = item;
    this.clickedValueChange.emit(this.clickedValue);
    this.auto.close();
  }

  async onChangeSearch(val: string) {
    var manualInput = new ServiceSearchKey();
    manualInput.value = val;
    this.clickedValueChange.emit(manualInput);
    this.initialValue = val;
    this.isLoading = true;
    if (val.length < this.MINIMUM_SEARCH_TERM_LENGTH) return;
    const serviceSearchKeyOption = {
      serviceId: this.serviceId,
      key: this.key,
      search: val,
    };
    const searchKeyResults: ServiceSearchKey[] =
      await this.dataService.getServiceSearchKey(serviceSearchKeyOption);
    this.data = searchKeyResults.map((result) => {
      return {
        value: result.value,
        description: result.description,
        dropdownName: `${result.value} (${result.description})`,
      };
    });
    this.isLoading = false;

    // This solves the issue where the suggestion box isn't displayed
    const interval = setInterval(() => {
      if (!this.auto.isOpen) this.auto.open();
      else clearInterval(interval);
    }, 300);
  }
}
